/**
 * NE4: kleine Bausteine für Firma, Team und Dispo (.595).
 *
 * ORIGINALTEXT MARVIN (02.11.2026)
 *   „Mach da lieber eine saubere Terminierung, Termine, dass die sauber
 *    hervorgehoben sind, dass das sauber zu lesen ist ... Guck dir das nochmal
 *    bei NE3 an und dann baust du das so für die Aufträge auch."
 *   „Wie zum Beispiel die Etagen, Wohneinheiten stehen da, ja, könnte man noch
 *    ein bisschen hervorheben."
 *
 * Der Termin als Marke wie die Gewerke-Marken der NE3-Liste (`.gewerk` mit
 * Datum darunter): blau gebucht, orange in Arbeit, grün fertig, rot nicht
 * erledigt. Die Hausdaten als große Zahlen.
 */
import { tagLang } from '../seiten/Ne4Arbeit.tsx';

const WT = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];

export function terminZustand(t: { zustand: string; begonnen?: boolean; begonnen_am?: string | null }): { klasse: string; wort: string } {
  if (t.zustand === 'ausgefuehrt') return { klasse: 'fertig', wort: 'fertig' };
  if (t.zustand === 'nicht_erledigt') return { klasse: 'nicht', wort: 'nicht erledigt' };
  if (t.begonnen || t.begonnen_am) return { klasse: 'arbeit', wort: 'in Arbeit' };
  return { klasse: 'gebucht', wort: 'gebucht' };
}

/** Ein Termintag als Marke: Wochentag und Datum groß, Uhrzeit, Tag x von y, Zustand. */
export function TerminMarke({ t, team }: { t: any; team?: string | null }) {
  const tag = String(t.tag).slice(0, 10);
  const z = terminZustand(t);
  const wt = WT[new Date(tag + 'T12:00:00Z').getUTCDay()];
  return (
    <span className={'ne4-terminmarke ' + z.klasse} title={`${tagLang(tag)} ${t.beginn ?? ''} Uhr, ${z.wort}${team ? `, ${team}` : ''}`}>
      <b>{wt} {tag.slice(8, 10)}.{tag.slice(5, 7)}.</b>
      <span>{String(t.beginn ?? '').slice(0, 5)} Uhr{t.block_tage > 1 ? `, Tag ${t.block_tag}/${t.block_tage}` : ''}</span>
      <span className="zustand">{z.wort}{team ? `, ${team}` : ''}</span>
    </span>
  );
}

/** Etagen, Wohneinheiten, Gewerbe, Sonderleitungen und Connects als große Zahlen. */
export function HausZahlen({ a, connects }: { a: any; connects?: { fertig: number; alle: number } }) {
  const feld = (zahl: any, wort: string) => (
    <div className="ne4-hauszahl"><b>{zahl ?? '–'}</b><span>{wort}</span></div>
  );
  return (
    <div className="ne4-hauszahlen">
      {feld(a.etagen, 'Etagen')}
      {feld(a.wohneinheiten, 'Wohneinheiten')}
      {feld(a.ge, 'Gewerbe')}
      {feld(a.sl, 'Sonderleitungen')}
      {connects && feld(`${connects.fertig}/${connects.alle}`, 'Connects fertig')}
    </div>
  );
}
